<template>
  <div class="card-modal-page">
    <CardModal v-if="loaded" />
    <AppLoadingProgressBars v-else />
  </div>
</template>

<script>
// Utilities
import store from 'Store'
import { EventBus } from '@/main'
import { checkApiResponse } from 'Utils'
// Components
import CardModal from 'Modules/Card/CardModal'
import AppLoadingProgressBars from 'Ui/AppLoadingProgressBars'

export default {
  name: 'CardModalPage',

  components: {
    CardModal,
    AppLoadingProgressBars,
  },

  props: {
    card_id: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      loaded: false,
    }
  },

  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      const card = await store.dispatch('cards/getCard', vm.card_id)
      // retrieving the requested card and checking for errors
      if (card.response && card.response.status === 404) {
        return next({
          name: '404-resource',
          params: { resource: vm.$t('ui.error_page.resource.action') },
        })
      } else if (checkApiResponse(card)) {
        if (from.name !== 'dashboard-client') {
          // loading the account of the current card
          const cardAccount = await store.dispatch(
            'client/load',
            store.state.cards.currentCard.account.id
          )

          if (!checkApiResponse(cardAccount[0])) return next(from)
        }
        // if data was loaded ⤵
        vm.$data.loaded = true
      } else {
        return next(from)
      }
    })
  },

  beforeDestroy() {
    EventBus.$emit('reload-user-content')
    this.$store.dispatch('cards/removeCurrentCard')
  },
}
</script>

<style scoped>
.card-modal-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 8px;
  min-height: 400px;
  background-color: #fff;
}
</style>
